/**
 * EAA-1822: best-effort Họ/Tên split for the edit-view identity card.
 *
 * There is no local "Họ"/"Tên" field anywhere in the ecosystem (D10: the token
 * carries only sub/email/name/sid) — this is a DISPLAY convenience so the edit
 * form isn't blank on first paint, not a real data source. Vietnamese naming
 * puts the family name (Họ) first and the given name (Tên) last, e.g.
 * "Nguyễn Thu Hà" -> Họ "Nguyễn", Tên "Thu Hà" — exactly frame 19's example.
 * A single-word name (no space) is treated as Tên only, Họ blank, rather than
 * guessing a split that doesn't exist.
 */
export interface SplitName {
    ho: string;
    ten: string;
}

export function splitVietnameseName(fullName: string | null | undefined): SplitName {
    const trimmed = (fullName ?? '').trim();
    if (!trimmed) {
        return { ho: '', ten: '' };
    }
    const parts = trimmed.split(/\s+/);
    if (parts.length === 1) {
        return { ho: '', ten: parts[0] };
    }
    return { ho: parts[0], ten: parts.slice(1).join(' ') };
}

export function joinVietnameseName(ho: string, ten: string): string {
    return [ho.trim(), ten.trim()].filter(Boolean).join(' ');
}
